export default __webpack_public_path__ + "static/badge_aws_security_specialty-8f5e9677b1e0ffe7c4fd45c77c93d54e.png";